// helpers
import DTM from 'shared/helpers/DTM';
import {
  landingPageRegex,
  ListingPageRegex,
  DetailsPageRegex,
  offerPageRegex,
} from 'shared/helpers/utils/regex';

const getPageName = () => {
  var path = window.location.pathname;

  if (path === '/') {
    return 'home';
  }

  if (landingPageRegex.test(path)) {
    return 'landing';
  }

  if (ListingPageRegex.test(path)) {
    return 'category_lising';
  }

  if (DetailsPageRegex.test(path)) {
    return 'product';
  }

  if (offerPageRegex.test(path)) {
    return 'offer';
  }

  return 'other';
};

export const onClickSendEvent = (data: Record<string, any>) => {
  const dwhData = {
    page_name: getPageName(),
    banner_namespace0: data['namespace0'] || undefined,
    banner_namespace1: data['namespace1'] || undefined,
    banner_namespace2: data['namespace2'] || undefined,
    banner_position1: data['position1'] || undefined,
    banner_position2: data['position2'] || undefined,
    banner_transaction_id: data['transaction_id'] || undefined,
  };

  DTM.track('ndn-banner-click', {
    bannerData: dwhData,
  });
};

export const onImpressionEvent = (data: Record<string, any> & { transaction_id: string }) => {
  if (!window.na) {
    return;
  }

  const dwhData = {
    page_name: getPageName(),
    banner_impressions: data['impressions'] || undefined,
    banner_namespace0: data['namespace0'] || undefined,
    banner_namespace1: data['namespace1'] || undefined,
    banner_namespace2: data['namespace2'] || undefined,
    banner_position1: data['position1'] || undefined,
    banner_position2: data['position2'] || undefined,
    banner_transaction_id: data['transaction_id'] || undefined,
  };

  // we could not use the DTM layer as by the time launch triggers DWH impression bannerData
  // variable is mutated causing wrong impression count
  window.na.sendImpressionEvent('banner_impression', dwhData);
};
